<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10.5" stroke="#000"/>
    <path d="M4 19.5L7.71723 16.2474C7.89952 16.0879 8.13351 16 8.37574 16H15.6243C15.8665 16 16.1005 16.0879 16.2828 16.2474L20 19.5" stroke="#000"/>
    <circle cx="12" cy="10.5" r="3" stroke="#000"/>
</svg>
